import { call, takeLatest, put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';

import { IPractitioner } from 'shared/interfaces/practitioner.interface';
import PractitionersService from 'shared/services/PractitionersService';

import {
  getPractitionersData,
  setPractitionersData,
  getPractitionersFail
} from './practitioners.redux';

function* getPractitioners() {
  try {
    const result: AxiosResponse<IPractitioner[]> = yield call(
      PractitionersService.getAllPractitioners
    );

    yield put(setPractitionersData(result));
  } catch (error) {
    console.log('error', error);
    yield put(getPractitionersFail());
  }
}

function* Practitioners() {
  yield takeLatest(getPractitionersData.type, getPractitioners);
}

export default Practitioners;
